<template>
    <div class="ibox">
        <div class="ibox-title ibox-grey"  v-if="!isPdfExport">
            <h4>{{ __('chart_show_analyze_results') }}</h4>
            <div class="ibox-tools">
                <button-open-help-modal v-if="showHelp == 1" :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-009' : 'ASB-009'"/>
            </div>
        </div>
    <div :class="[{'ibox-content':!isPdfExport}]">
        <div class="row justify-content-center">
            <div class="col-12 ">
                <line-basic v-if="chartData.complete && chartData.name=='line_basic'"
                            :chartData="chartData"
                            :documents="documentsWithChangedGroupOtherNames"
                            :analyzeType="analyzeType"
                            :analyze-level="analyzeLevel"
                            :currency="currency">
                </line-basic>

                <area-basic v-if="chartData.complete && chartData.name=='area_basic'"
                            :chartData="chartData"
                            :documents="documentsWithChangedGroupOtherNames"
                            :analyzeType="analyzeType"
                            :analyze-level="analyzeLevel"
                            :currency="currency"
                ></area-basic>

                <column-with-data-labels v-if="chartData.complete && chartData.name=='column_with_data_labels'"
                             :chartData="chartData"
                             :documents="documentsWithChangedGroupOtherNames"
                             :analyzeType="analyzeType"
                             :analyze-level="analyzeLevel"
                             :currency="currency"
                ></column-with-data-labels>

                <column-with-rotated-labels v-if="chartData.complete && chartData.name=='column_with_rotated_labels'"
                            :chartData="chartData"
                            :documents="documentsWithChangedGroupOtherNames"
                            :analyzeType="analyzeType"
                            :analyze-level="analyzeLevel"
                            :currency="currency"
                >
                </column-with-rotated-labels>

                <column-with-data-inside v-if="chartData.complete && chartData.name=='column_with_data_inside'"
                                            :chartData="chartData"
                                            :documents="documentsWithChangedGroupOtherNames"
                                            :analyzeType="analyzeType"
                                            :analyze-level="analyzeLevel"
                                            :currency="currency"
                >
                </column-with-data-inside>

                <bar-basic v-if="chartData.complete && chartData.name=='bar_basic'"
                           :chartData="chartData"
                           :documents="documentsWithChangedGroupOtherNames"
                           :analyzeType="analyzeType"
                           :analyze-level="analyzeLevel"
                           :currency="currency"
                ></bar-basic>

                <bar-with-category-name-and-label-inside
                    v-if="chartData.complete && chartData.name=='bar_with_category_name_and_label_inside'"
                    :chartData="chartData"
                    :documents="documentsWithChangedGroupOtherNames"
                    :analyzeType="analyzeType"
                    :analyze-level="analyzeLevel"
                    :currency="currency"
                >
                </bar-with-category-name-and-label-inside>

                <simple-pie v-if="chartData.complete && chartData.name=='simple_pie'"
                            :chartData="chartData"
                            :documents="documentsWithChangedGroupOtherNames"
                            :analyzeType="analyzeType"
                            :analyze-level="analyzeLevel"
                            :currency="currency">
                </simple-pie>

                <simple-donut v-if="chartData.complete && chartData.name=='simple_donut'"
                              :chartData="chartData"
                              :documents="documentsWithChangedGroupOtherNames"
                              :analyzeType="analyzeType"
                              :analyze-level="analyzeLevel"
                              :currency="currency">

                </simple-donut>
                <monochrome-pie v-if="chartData.complete && chartData.name=='monochrome_pie'"
                                :chartData="chartData"
                                :documents="documentsWithChangedGroupOtherNames"
                                :analyzeType="analyzeType"
                                :analyze-level="analyzeLevel"
                                :currency="currency">

                </monochrome-pie>
                <gradient-donut v-if="chartData.complete && chartData.name=='gradient_donut'"
                                :chartData="chartData"
                                :documents="documentsWithChangedGroupOtherNames"
                                :analyzeType="analyzeType"
                                :analyze-level="analyzeLevel"
                                :currency="currency">

                </gradient-donut>

                <semi-donut v-if="chartData.complete && chartData.name=='semi_donut'"
                            :chartData="chartData"
                            :documents="documentsWithChangedGroupOtherNames"
                            :analyzeType="analyzeType"
                            :analyze-level="analyzeLevel"
                            :currency="currency">

                </semi-donut>
                <radar-basic v-if="chartData.complete && chartData.name=='radar_basic'"
                             :chartData="chartData"
                             :documents="documentsWithChangedGroupOtherNames"
                             :analyzeType="analyzeType"
                             :analyze-level="analyzeLevel"
                             :currency="currency">

                </radar-basic>
                <line-many v-if="chartData.complete && chartData.name=='line_many'"
                           :chartData="chartData"
                           :documents="documentsWithChangedGroupOtherNames"
                           :analyzeType="analyzeType"
                           :analyze-level="analyzeLevel"
                           :currency="currency">
                </line-many>

                <line-synchronized v-if="chartData.complete && chartData.name=='line_synchronized'"
                                   :chartData="chartData"
                                   :documents="documentsWithChangedGroupOtherNames"
                                   :analyzeType="analyzeType"
                                   :analyze-level="analyzeLevel"
                                   :currency="currency">
                </line-synchronized>

                <column-basic v-if="chartData.complete && chartData.name=='column_basic'"
                              :chartData="chartData"
                              :documents="documentsWithChangedGroupOtherNames"
                              :analyzeType="analyzeType"
                              :analyze-level="analyzeLevel"
                              :currency="currency">
                </column-basic>

                <stacked-column v-if="chartData.complete && chartData.name=='stacked_column'"
                                :chartData="chartData" :documents="documentsWithChangedGroupOtherNames"
                                :analyzeType="analyzeType"
                                :analyze-level="analyzeLevel"
                                :currency="currency">

                </stacked-column>

                <stacked-column100 v-if="chartData.complete && chartData.name=='stacked_column_100'"
                                   :chartData="chartData"
                                   :documents="documentsWithChangedGroupOtherNames"
                                   :analyzeType="analyzeType"
                                   :analyze-level="analyzeLevel"
                                   :currency="currency">

                </stacked-column100>

                <bar-grouped v-if="chartData.complete && chartData.name=='bar_grouped'"
                             :chartData="chartData"
                             :documents="documentsWithChangedGroupOtherNames"
                             :analyzeType="analyzeType"
                             :analyze-level="analyzeLevel"
                             :currency="currency"
                >

                </bar-grouped>

                <stacked-bar v-if="chartData.complete && chartData.name=='stacked_bar'"
                             :chartData="chartData"
                             :documents="documentsWithChangedGroupOtherNames"
                             :analyzeType="analyzeType"
                             :analyze-level="analyzeLevel"
                             :currency="currency">

                </stacked-bar>

                <stacked-bar100 v-if="chartData.complete && chartData.name=='stacked_bar_100'"
                                :chartData="chartData"
                                :documents="documentsWithChangedGroupOtherNames"
                                :analyzeType="analyzeType"
                                :analyze-level="analyzeLevel"
                                :currency="currency"
                >

                </stacked-bar100>

                <radar-multi-series v-if="chartData.complete && chartData.name=='radar_multi_series'"
                                    :chartData="chartData"
                                    :documents="documentsWithChangedGroupOtherNames"
                                    :analyzeType="analyzeType"
                                    :analyze-level="analyzeLevel"
                                    :currency="currency">

                </radar-multi-series>

                <area-basic-multi v-if="chartData.complete && chartData.name=='area_basic_multi'"
                                  :chartData="chartData" :documents="documentsWithChangedGroupOtherNames"
                                  :analyzeType="analyzeType"
                                  :analyze-level="analyzeLevel"
                                  :currency="currency">
                </area-basic-multi>

                <column-with-data-labels-multi
                    v-if="chartData.complete && chartData.name=='column_with_data_labels_multi'"
                    :chartData="chartData"
                    :documents="documentsWithChangedGroupOtherNames"
                    :analyzeType="analyzeType"
                    :analyze-level="analyzeLevel"
                    :currency="currency">

                </column-with-data-labels-multi>

                <simple-pie-multi v-if="chartData.complete && chartData.name=='simple_pie_multi'"
                                  :chartData="chartData" :documents="documentsWithChangedGroupOtherNames"
                                  :analyze-level="analyzeLevel"
                                  :analyzeType="analyzeType"
                                  :currency="currency">

                </simple-pie-multi>

                <simple-donut-multi v-if="chartData.complete && chartData.name=='simple_donut_multi'"
                                    :chartData="chartData"
                                    :documents="documentsWithChangedGroupOtherNames"
                                    :analyze-level="analyzeLevel"
                                    :analyzeType="analyzeType"
                                    :currency="currency">

                </simple-donut-multi>
                <monochrome-pie-multi v-if="chartData.complete && chartData.name=='monochrome_pie_multi'"
                                      :chartData="chartData"
                                      :documents="documentsWithChangedGroupOtherNames"
                                      :analyze-level="analyzeLevel"
                                      :analyzeType="analyzeType"
                                      :currency="currency">

                </monochrome-pie-multi>

                <gradient-donut-multi v-if="chartData.complete && chartData.name=='gradient_donut_multi'"
                                      :chartData="chartData"
                                      :documents="documentsWithChangedGroupOtherNames"
                                      :analyze-level="analyzeLevel"
                                      :analyzeType="analyzeType"
                                      :currency="currency">

                </gradient-donut-multi>

                <semi-donut-multi v-if="chartData.complete && chartData.name=='semi_donut_multi'"
                                  :chartData="chartData"
                                  :documents="documentsWithChangedGroupOtherNames"
                                  :analyze-level="analyzeLevel"
                                  :analyzeType="analyzeType"
                                  :currency="currency">

                </semi-donut-multi>

                <line-many-multi v-if="chartData.complete && chartData.name=='line_many_multi'"
                                 :chartData="chartData"
                                 :documents="documentsWithChangedGroupOtherNames"
                                 :analyze-level="analyzeLevel"
                                 :analyzeType="analyzeType"
                                 :currency="currency">

                </line-many-multi>
                <column-basic-multi v-if="chartData.complete && chartData.name=='column_basic_multi'"
                                    :chartData="chartData"
                                    :documents="documentsWithChangedGroupOtherNames"
                                    :analyze-level="analyzeLevel"
                                    :analyzeType="analyzeType"
                                    :currency="currency">

                </column-basic-multi>
                <stacked-column-multi v-if="chartData.complete && chartData.name=='stacked_column_multi'"
                                      :chartData="chartData"
                                      :documents="documentsWithChangedGroupOtherNames"
                                      :analyze-level="analyzeLevel"
                                      :analyzeType="analyzeType"
                                      :currency="currency">

                </stacked-column-multi>

                <stacked-column100-multi v-if="chartData.complete && chartData.name=='stacked_column_100_multi'"
                                         :chartData="chartData"
                                         :documents="documentsWithChangedGroupOtherNames"
                                         :analyze-level="analyzeLevel"
                                         :analyzeType="analyzeType"
                                         :currency="currency">

                </stacked-column100-multi>

                <radar-multi-series-multi v-if="chartData.complete && chartData.name=='radar_multi_series_multi'"
                                          :chartData="chartData"
                                          :documents="documentsWithChangedGroupOtherNames"
                                          :analyze-level="analyzeLevel"
                                          :analyzeType="analyzeType"
                                          :currency="currency">

                </radar-multi-series-multi>
            </div>

        </div>

    </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import ColumnWithRotatedLabels from "./charts/ColumnWithRotatedLabels";
import BarBasic from "./charts/BarBasic";
import BarWithCategoryNameAndLabelInside from "./charts/BarWithCategoryNameAndLabelInside";
import MonochromePie from "./charts/MonochromePie";
import RadarBasic from "./charts/RadarBasic";
import ColumnBasic from "./charts/ColumnBasic";
import StackedColumn from "./charts/StackedColumn";
import StackedColumn100 from "./charts/StackedColumn100";
import BarGrouped from "./charts/BarGrouped";
import StackedBar from "./charts/StackedBar";
import StackedBar100 from "./charts/StackedBar100";
import RadarMultiSeries from "./charts/RadarMultiSeries";
import AreaBasicMulti from "./charts/AreaBasicMulti";
import ColumnWithDataLabelsMulti from "./charts/ColumnWithDataLabelsMulti";
import SimplePieMulti from "./charts/SimplePieMulti";
import SimpleDonutMulti from "./charts/SimpleDonutMulti";
import MonochromePieMulti from "./charts/MonochromePieMulti";
import GradientDonutMulti from "./charts/GradientDonutMulti";
import SemiDonutMulti from "./charts/SemiDonutMulti";
import LineManyMulti from "./charts/LineManyMulti";
import ColumnBasicMulti from "./charts/ColumnBasicMulti";
import StackedColumnMulti from "./charts/StackedColumnMulti";
import StackedColumn100Multi from "./charts/StackedColumn100Multi";
import RadarMultiSeriesMulti from "./charts/RadarMultiSeriesMulti";
import ColumnWithDataInside from "./charts/ColumnWithDataInside";

export default {
    components: {
        ColumnWithDataInside,
        RadarMultiSeriesMulti,
        StackedColumn100Multi,
        StackedColumnMulti,
        ColumnBasicMulti,
        LineManyMulti,
        SemiDonutMulti,
        GradientDonutMulti,
        MonochromePieMulti,
        SimpleDonutMulti,
        SimplePieMulti,
        ColumnWithDataLabelsMulti,
        AreaBasicMulti,
        RadarMultiSeries,
        StackedBar100,
        StackedBar,
        BarGrouped,
        StackedColumn100,
        StackedColumn,
        ColumnBasic,
        RadarBasic,
        MonochromePie,
        BarWithCategoryNameAndLabelInside,
        BarBasic,
        ColumnWithRotatedLabels,
        apexchart: VueApexCharts,
    },
    props: {
        documents: {
            type: Array
        },
        chartData: {
            type: Object
        },
        analyzeType: {
            type: String
        },
        analyzeLevel: {
            type: Object
        },
        currency: {
            type: String
        },
        showHelp:{
            type: Number,
            default:1
        },
        isPdfExport:{
            type: Boolean,
            default:false
        }
    },
    data() {
        return {
            level_1: null,
            level_2: null,
            test: this.chartData.complete
        }
    },
    computed: {
        documentsWithChangedGroupOtherNames() {
            return this.documents.map(doc => {
                if (doc.order_item_order === 1000) {
                    doc.order_item_name = this.__('rest_items');
                }
                if (doc.contractor_item_order === 1000) {
                    doc.contractor_item_name = this.__('rest_contractors');
                }
                if (doc.currency_item_order === 1000) {
                    doc.currency_item_name = this.__("rest_currencies");
                }
                return doc;
            });
        },
        chartTypeOptions() {
            return [
                {text: 'Liniowy', 'id': 'line'},
                {text: 'Radar', 'id': 'radar'},
            ]
        },
        chartGroupOptions() {
            return [
                {text: 'Kontrahent', 'id': 'contractor_item_name'},
                {text: 'Towar', 'id': 'order_item_name'},
                {text: 'Data', 'id': 'date_item_name'},
            ]
        },
        displayDiagrams() {
            return this.level_1 != null
        },
        chartLength() {
            if (this.level_1 != null && this.level_2 == null) {
                return 1;
            }
            return 0
        },
        getDiagramObject() {
            if (this.level_1 != null && this.level_2 == null) {
                return this.groupArrayByProperty(this.documents, this.level_1)
            }
            if (this.level_1 != null && this.level_2 != null) {
                return this.groupArrayByProperty(this.documents, this.level_1)
            }
            return {}
        },
        getSeries() {
            if (this.level_1 != null && this.level_2 == null) {
                let objectSum = this.sumObjectsByKey(this.documents, this.level_1)
                return [{
                    name: '',
                    data: objectSum.map((item) => item.data),
                    x_axis: objectSum.map((item) => item.name)
                }]
            }
        }
    },
    methods: {
        sumObjectsByKey(arr, key) {
            const uniqueValues = new Set();
            const result = [];

            // Pierwsza pętla, aby znaleźć unikalne wartości
            for (const obj of arr) {
                if (obj.hasOwnProperty(key)) {
                    uniqueValues.add(obj[key]);
                }
            }

            // Druga pętla, aby zsumować wartości dla każdej unikalnej wartości
            for (const value of uniqueValues) {
                let sum = 0;
                for (const obj of arr) {
                    if (obj[key] === value) {
                        sum += obj.net_in_base_currency; // Zakładam, że wartość, którą chcesz zsumować, znajduje się w kluczu 'value'
                    }
                }
                result.push({'name': value, data: sum});
            }

            return result;
        },
        countUniqueValuesByKey(arr, key) {
            const uniqueValues = new Set();
            for (const obj of arr) {
                if (obj.hasOwnProperty(key)) {
                    uniqueValues.add(obj[key]);
                }
            }
            return uniqueValues.size;
        },
        groupArrayByProperty(arr, key) {
            return arr.reduce((grouped, obj) => {
                const propertyValue = obj[key];
                if (!grouped[propertyValue]) {
                    grouped[propertyValue] = [];
                }
                grouped[propertyValue].push(obj);
                return grouped;
            }, {});
        },

    },
};
</script>
